/**
 * @packageDocumentation
 * @module      RoboticNetwork.ts
 * @description Models a robotic network
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
import System from "./System";
export default class RoboticNetwork {
    constructor(roboticNetworkId, roboticNetworkName, systems) {
        this.systems = [];
        this.roboticNetworkId = roboticNetworkId || null;
        this.roboticNetworkName = roboticNetworkName || '';
        this.systems = systems || [];
    }
    toJSON() {
        const jsonObj = Object.assign({}, this);
        jsonObj.roboticNetworkId = this.roboticNetworkId;
        jsonObj.roboticNetworkName = this.roboticNetworkName;
        jsonObj.systems = this.systems.map((s) => s.toJSON());
        return jsonObj;
    }
    /**
     * Return a RoboticNetwork object, with systems, built from a JSON object that might be returned from the server.
     *
     * @param json JSON representation of a robotic network and its devices.
     */
    static fromJSON(json) {
        let rn = new RoboticNetwork();
        rn.roboticNetworkId = json.roboticNetworkId;
        rn.roboticNetworkName = json.roboticNetworkName;
        for (let sys of json.systems) {
            rn.systems.push(System.fromJSON(sys));
        }
        return rn;
    }
}
//# sourceMappingURL=RoboticNetwork.js.map